import Alpine from 'alpinejs'
import axios from 'axios'

Alpine.data('feeds', () => ({
    feeds: [],
    form: {
        username: null,
        limit: 20,
    },
    updateForm: {
        show: false,
        data: null,
    },
    loading_feeds: true,

    init() {
        this.loadFeeds()
    },

    loadFeeds() {
        axios.get('/feeds').then(res => {
            this.feeds = res.data
            this.loading_feeds = false
            console.log(this.feeds);
        })
    },

    editFeed(feed) {
        this.updateForm.data = feed
        this.updateForm.show = true
    },

    deleteFeed(id) {
        if(confirm('Are you sure ?')) {
            axios.delete(`/feeds/${id}`).then(res => {
                setNotification({
                    text: res.data.message,
                    notificationType: 'success'
                })

                return this.loadFeeds()
            }).catch(err => {
                setNotification({
                    text: err.response.data.message,
                    notificationType: 'error'
                })
            })
        }
    },

    submit() {
        axios.post('/feeds', this.form).then(res => {
            // this.loadFeeds()
            setNotification({
                text: res.data.message,
                notificationType: 'success'
            });

            window.location.href = res.data.auth_url;
        }).catch(err => {
            setNotification({
                text: err.response.data.message,
                notificationType: 'error'
            })
        })
    },

    updateProfile() {
        axios.put(`/feeds/${this.updateForm.data.id}`, this.updateForm.data)
            .then(res => {
                setNotification({
                    text: res.data.message,
                    notificationType: 'success'
                })

                this.loadFeeds()

                setTimeout(() => {
                    this.updateForm.show = false
                }, 200)
            }).catch(err => {
                setNotification({
                    text: err.response.data.message,
                    notificationType: 'error'
                })
            })
    }
}))
